import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import Tabs from '../../../../components/tabs';
import TimesheetsList from './../../lists/timesheets';
import { submitAllTimesheets, approveAllTimesheets } from '../../../../reducers/timekeeping';

class AdminTime extends React.Component {
    constructor(props) {
        super(props);

        this.renderAdminControls = this.renderAdminControls.bind(this);
    }

    renderAdminControls() {
        const { details, submitAllTimesheets } = this.props;
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="action-button" onClick={() => submitAllTimesheets(details.id)}>
                        <i className="material-icons">done</i>
                        <FormattedMessage {...messages.submitAllTimesheets} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let tabs = [
            { title: <FormattedMessage {...messages.general} />, content: this.renderAdminControls() },
            { title: <FormattedMessage {...messages.toApprove} />, content: <TimesheetsList key={0} filter={['submitted', 'notapproved']} /> },
            { title: <FormattedMessage {...messages.approved} />, content: <TimesheetsList key={1} filter={['approved', 'autoapproved']} /> },
            { title: <FormattedMessage {...messages.disputed} />, content: <TimesheetsList key={2} filter={'disputed'} /> },
            { title: <FormattedMessage {...messages.rejected} />, content: <TimesheetsList key={3} filter={'rejected'} /> },
            { title: <FormattedMessage {...messages.pending} />, content: <TimesheetsList key={4} filter={'pending'} />, style: 'light' }
        ];

        return (
            <React.Fragment>
                <Tabs items={tabs} pageWide title={<FormattedMessage {...messages.timesheets} />} isPageTitle={true} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            submitAllTimesheets,
            approveAllTimesheets
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminTime);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/tenants/admin/index.jsx